// extracted by mini-css-extract-plugin
export default {"PageTitle":"HkBKrMaG"};